import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import Plus from '@icons/Plus';
import { pressActionEffect } from '@styles/mixin';
import { Trans, useTranslation } from 'react-i18next';

import useRegisterKiccEasyCard from '../../hooks/useRegisterKiccEasyCard';

function BlankEasyCard() {
    const { t } = useTranslation('easyCard');
    const { handleRegisterCard } = useRegisterKiccEasyCard();
    return (
        <Container spacing={10} fullWidth align='center'>
            <AddButton onClick={handleRegisterCard}>
                <Plus/>
                <Text size='title-lg'>
                    {t('blank.register')}
                </Text>
            </AddButton>
            <Text align='center' size='title' color={colors.textSecondary}>
                <Trans ns='easyCard'
                    i18nKey='blank.description'
                    components={{ br: <br/>, b: <b/> }} />
            </Text>
        </Container>
    );
}

const Container = styled(Column)`
    //padding: var(--spacing-4);
    padding:16px;
`;

const AddButton = styled.button`
    background-color: transparent;
    //border: 2px dashed var(--color-border-disabled);
    border: 2px dashed ${colors.gray5};
    //border-radius: var(--radius-lg);
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    //gap: var(--spacing-2);
    gap: 8px;
    width: 100%;
    aspect-ratio: 1.5;
    ${pressActionEffect}
`;

export default BlankEasyCard;
